import { Component, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { FileUploadComponent } from '@group24ag/flowkit';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-ui-file-upload',
  imports: [FileUploadComponent, FaIconComponent],
  template: `
    <div>
      <h1 class="heading-title">File Upload</h1>
      <div class="flex flex-col gap-10">
        <ng-template #initialTemplateRef>
          <fa-icon
            class="text-dune-400 group-hover:text-greenish-300 dark:text-dune-200 mb-2 transition-colors transition-transform duration-200 group-hover:scale-110"
            [icon]="['fas', 'cloud-arrow-up']"
            [size]="'2x'"></fa-icon>
          <span class="text-center">Drag your document here</span>
          <span class="text-center"
            >Keep in mind that pdf files are allowed</span
          >
        </ng-template>
        <flk-file-upload
          class="w-96"
          [label]="'Upload your files here'"
          [accept]="'application/pdf'"
          [validateFile]="validateFile"
          [initialTemplate]="initialTemplateRef">
        </flk-file-upload>
      </div>
    </div>
  `,
})
export class UIFileUploadComponent {
  private readonly library = inject(FaIconLibrary);
  private readonly logger = inject(NGXLogger);

  validateFile = (file: File): boolean => {
    this.logger.warn(
      file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
    );
    return (
      file.type === 'application/pdf' ||
      file.name.toLowerCase().endsWith('.pdf')
    );
  };

  constructor() {
    this.library.addIcons(faCloudArrowUp);
  }
}
